import styled from "styled-components";
import { useTranslation } from "react-i18next";

type Props = {
    message: string;
};

const BannerInformation = ({ message }: Props) => {
    const { t } = useTranslation();

    return (
        <BannerWrapper>
            <p>{t(message)}</p>
        </BannerWrapper>
    );
};

const BannerWrapper = styled.div`
    width: 99%;
    background: #fffbea;
    padding: 4px;
    position: absolute;
    > p {
        font-size: 15px;
        margin: 0;
        text-align: center;
        color: #7a6f3c;
    }
`;
export default BannerInformation;
